export var StoreID;

(function (StoreID) {
  StoreID[StoreID["Cofit"] = 6] = "Cofit";
  StoreID[StoreID["Genesis"] = 16] = "Genesis";
})(StoreID || (StoreID = {}));